import { PubSub } from "@aws-amplify/pubsub";

export const pubsub = new PubSub({
  region: "eu-west-1",
  endpoint: "wss://aa548ngrivwoo-ats.iot.eu-west-1.amazonaws.com/mqtt",
});
